/* Copyright (c) 2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Overlay, CloseScrollStrategy } from '@angular/cdk/overlay';

/**
 * Factory function that creates a CloseScrollStrategy for mat-select components.
 * This strategy will close the dropdown when the user scrolls.
 *
 * @param overlay The Angular CDK Overlay service
 * @returns A factory function that creates a CloseScrollStrategy
 */
export function closeScrollFactory(overlay: Overlay): () => CloseScrollStrategy {
    return () => overlay.scrollStrategies.close();
}
